<template>
  <v-app>
    <AppSidebar v-if="isLogin && route_params.org_id && $route.path.includes('page_editor') === false"></AppSidebar>
    <v-main v-if="isLogin === true && route_params.org_id">
      <v-container
        fluid
        style="height: 100%"
        :class="{
          'pa-0': $route.path.includes('page_editor') === true,
        }"
      >
        <PageLoader v-if="is_page_loading" />
        <router-view v-else />
      </v-container>
    </v-main>
    <router-view v-else />

    <vtoast ref="vtoast" />
    <VProgress ref="VProgress" />
  </v-app>
</template>

<script>
// 載入Vuex Helper
import { mapGetters } from 'vuex'
import { apiGetSubscriptionInfo } from '@/api/organize.js'
import { apiGetReadmeInfo } from '@/api/admin'
import AppSidebar from './AppSidebar.vue'
import vtoast from '@/components/Utils/VToast.vue'
import VProgress from '@/components/Utils/VProgress.vue'
import store from '@/store/index.js'
import PageLoader from './AppPageLoader.vue'
import Description from '@/components/Utils/Description.vue'
import { mountDynamicComponent, removeObserver, createDynamicComponent } from '@/composables/mountDynamicComponent'

export default {
  name: 'AppLayout',
  components: {
    AppSidebar,
    vtoast,
    PageLoader,
    VProgress,
  },

  data: () => ({
    is_auth: false,
    store,
    readme_infos: [],
  }),
  computed: {
    isLogin: {
      get() {
        return this.$store.getters.loggedStatus
      },
      set(value) {
        return value
      },
    },
    route_params() {
      return this.$route.params
    },
    ...mapGetters(['loggedStatus', 'is_page_loading']),
  },
  watch: {
    $route: {
      async handler(to) {
        removeObserver()
        if (!to.path.match('/partner/readme_map')) {
          await this.getReadmeInfo()
          const ready_mount_components_info = []
          // 取符合路徑的元件資料
          for (const item of this.readme_infos) {
            const is_multiple_page = item.trigger_link.endsWith('/')
            const comparePath = is_multiple_page
              ? to.fullPath.match(item.trigger_link)
              : to.fullPath.endsWith(item.trigger_link)
            if (comparePath) {
              ready_mount_components_info.push({
                keyword: item.trigger_anchor,
                link: item.help_link,
                description: item.help_note,
              })
            }
          }

          if (ready_mount_components_info.length) {
            this.mountDescriptionComponent(ready_mount_components_info)
          }
        }
      },
    },
  },
  async created() {
    let org_id = ''
    const match = window.location.href.match(/https?:\/\/[^/]+\/([^/]+)/)
    org_id = match ? match[1] : null

    if (org_id && org_id.length === 32) {
      let quota = null
      try {
        quota = await apiGetSubscriptionInfo(org_id)
        this.$store.commit('update_member_quota', { org_id: org_id, quota: quota.data.data })
      } catch (error) {
        console.error('app_index_quota_error', error)
      }
    }
  },
  mounted() {
    this.$root.vtoast = this.$refs.vtoast
    this.$root.vprogress = this.$refs.VProgress
    if (this.loggedStatus && this.$router.history.current.fullPath === '/login') {
      return false
    }
  },
  methods: {
    mountDescriptionComponent(data) {
      // made all component
      const components_main = {}
      data.forEach((item) => {
        components_main[item.keyword] = createDynamicComponent(Description, {
          descriptionText: item.description,
          link: item.link,
        })
      })

      const matchText = (target) => {
        const match_list = []
        for (const node of target.childNodes) {
          if (Object.keys(components_main).includes(node.textContent.trim())) {
            // 只會拿符合條件的 p 或 text
            if (node.nodeName === 'P' || !node.childNodes.length) {
              match_list.push(node)
            }
          }
          // 如果遍歷到 p 標籤就結束
          if (node.childNodes.length && node.nodeName !== 'P') {
            const res = matchText(node)
            match_list.push(...res)
          }
        }
        return match_list
      }

      this.$nextTick(() => {
        mountDynamicComponent((mutations) => {
          for (const mutation of mutations) {
            const match_res = matchText(mutation.target)
            match_res.forEach((item) => {
              // 判斷要從哪個節點開始把東西包進 div 內
              let target_el = null
              if (item.parentElement.parentElement.nodeName === 'P') {
                target_el = item.parentElement.parentElement
              } else if (item.parentElement.nodeName === 'SPAN') {
                target_el = item.parentElement
              } else {
                target_el = item
              }

              // 把東西包進 div，有 data-description 表示處理過了
              if (target_el && !target_el.parentElement.getAttribute('data-description')) {
                const div_el = document.createElement('div')
                div_el.setAttribute('data-description', true)
                target_el.before(div_el)
                div_el.appendChild(target_el)
                div_el.setAttribute('style', 'display: flex; align-items: center;')
                div_el.appendChild(components_main[item.textContent.trim()].$el)
              }
            })
          }
        })
      })
    },
    async getReadmeInfo() {
      try {
        const is_change = sessionStorage.getItem('readme_map_is_change')
          ? JSON.parse(sessionStorage.getItem('readme_map_is_change'))
          : true
        if (is_change) {
          this.readme_infos = await apiGetReadmeInfo()
          sessionStorage.setItem('readme_map_config', JSON.stringify(this.readme_infos))
          sessionStorage.setItem('readme_map_is_change', 'false')
        } else {
          this.readme_infos = JSON.parse(sessionStorage.getItem('readme_map_config'))
        }
      } catch (error) {
        console.error('getReadmeInfo() error :', error)
        this.$root.vtoast.show({ message: this.$t('common.getDataError', { reason: error }), color: 'error' })
      }
    },
  },
}
</script>

<style>
.gap {
  gap: 12px;
}

.text_primary {
  color: #008edd !important;
}

.text_default {
  color: #666 !important;
}

.btn_default {
  border: 1px solid #ccc !important;
}

.btn_default_bg_linear {
  background: linear-gradient(180deg, #fff, #f0f0f0) !important;
}

.btn_action {
  color: #fff !important;
  border: 1px solid #0f88c5 !important;
}
.btn_action_bg_linear {
  background: linear-gradient(180deg, #20a6f2, #1092d3) !important;
}

.btn-danger {
  background: #e3262e;
  background-image: linear-gradient(180deg, #e3262e, #ab171e);
  border-radius: 4px;
  color: #fff !important;
  border: 1px solid #ab171e;
  text-decoration: none;
  min-width: 40px;
  box-shadow: inset 0 1px 1px #ff7b81, 0 2px 2px -1px rgba(0, 0, 0, 0.2);
}

.btn-primary {
  background: #20a6f2;
  background-image: linear-gradient(180deg, #20a6f2, #1092d3);
  border-radius: 4px;
  color: #fff !important;
  border: 1px solid #0f88c5;
  text-decoration: none;
  min-width: 32px;
  box-shadow: inset 0 1px 1px #77bdf4, 0 2px 2px -1px rgba(0, 0, 0, 0.2);
}

.btn-warning {
  background: #f0ad4e;
  background-image: linear-gradient(180deg, #f0ad4e, #f7a635);
  border-radius: 4px;
  color: #fff;
  border: 1px solid #f69c1e;
  text-decoration: none;
  min-width: 32px;
  box-shadow: inset 0 1px 1px #f9c173, 0 2px 2px -1px rgba(0, 0, 0, 0.2);
}

.floating {
  animation: float 1.8s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

::selection {
  color: #fff;
  background: #353e4d;
}

.mt-10 {
  margin-top: 10px;
}

.setting-main {
  overflow: scroll;
}

.setting-main > article {
  background-color: #ffffff;
  border-bottom: 1px #ccc solid;
  padding: 1em;
  overflow: scroll;
}
div.container--fluids {
  padding: 0 !important;
}
.table-row-pointer {
  cursor: pointer;
  color: #1a73e8;
}
.table-row-pointer:hover {
  color: #174ea6;
  text-decoration: underline;
}
.table-truncate {
  margin: 0;
  padding: 0;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

h5 {
  padding-bottom: 1em;
  font-weight: 500;
  font-size: 1.1em;
  display: flex;
}
.full-tabs .v-tab {
  max-width: 100% !important;
}
.row-pointer {
  cursor: pointer;
  color: #5087e6;
}
.row-pointer:hover {
  color: #5087e6;
  text-decoration: underline;
}
</style>
